<svg
	width="100%"
	height="100%"
	viewBox="0 0 14 17"
	version="1.1"
	style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
>
	<g transform="matrix(1,0,0,1,-10.6667,-7.73588)">
		<path
			d="M12.7,24.033C12.256,24.322 11.806,24.339 11.351,24.084C10.896,23.829 10.668,23.434 10.667,22.9L10.667,9.1C10.667,8.567 10.895,8.172 11.351,7.916C11.807,7.66 12.256,7.677 12.7,7.967L23.567,14.867C23.967,15.133 24.167,15.511 24.167,16C24.167,16.489 23.967,16.867 23.567,17.133L12.7,24.033Z"
			style="fill:currentColor;fill-rule:nonzero;"
		/>
	</g>
</svg>
